import { NavItem } from '../types/navigation';

export const navItems: NavItem[] = [
  { label: 'O Nas', href: '#about' },
  { label: 'Portfolio', href: '/portfolio', isInternal: true },
  { label: 'Blog', href: '/blog', isInternal: true, isPersistent: true },
  { label: 'Proces', href: '#process' },
  { label: 'FAQ', href: '#faq' }
];

export const getNavItems = (): NavItem[] => {
  const hasBlog = navItems.some(item => item.href === '/blog');
  
  if (!hasBlog) {
    console.error('Blog nie znaleziony w elementach nawigacji! Naprawianie...');
    return [
      ...navItems,
      { label: 'Blog', href: '/blog', isInternal: true, isPersistent: true }
    ];
  }
  
  return [...navItems];
};

export const getCompleteNavItems = (): NavItem[] => {
  const items = getNavItems();
  
  const hasBlog = items.some(item => item.href === '/blog');
  if (!hasBlog) {
    items.push({ label: 'Blog', href: '/blog', isInternal: true, isPersistent: true });
  }
  
  return items;
};
